import React from "react";
import DateHelper from "../DateHelper/DateHelper";
import ModalButtons from "../ModalButtons/ModalButtons";
import ModalHeader from "../ModalButtons/ModalHeader";
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner";
import IncidentalDepositBuilderGeneral from "./tabs/IncidentalDepositBuilderGeneral";
import Tabs from '../Tabs/Tabs';
import IncidentalDepositBuilderErrors from './IncidentalDepositBuilderErrors';
import IncidentalDepositBuilderTabContent from "./IncidentalDepositBuilderTabContent";

class IncidentalDepositBuilder extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      active_tab: 'general',
      incidental_deposit: this.props.incidental_deposit,
      maintain_authorization: this.props.incidental_deposit && this.props.incidental_deposit.reauthorize ? true : false,
      all_room_types: this.props.all_room_types ? this.props.all_room_types : null,
      errors: this.props.errors || [],
    }

    this.onChangeActiveTab = this.onChangeActiveTab.bind(this)
    this.onChange = this.onChange.bind(this)
    this.onChangeDepositType = this.onChangeDepositType.bind(this)
    this.onChangeAuthorize = this.onChangeAuthorize.bind(this)
    this.onChangeAmount = this.onChangeAmount.bind(this)
    this.onChangePercentage = this.onChangePercentage.bind(this)
    this.onChangeNights = this.onChangeNights.bind(this)
    this.onChangeIncludeBalance = this.onChangeIncludeBalance.bind(this)
    this.onChangeReauthorization = this.onChangeReauthorization.bind(this)
    this.onChangeMaintainAuthorization = this.onChangeMaintainAuthorization.bind(this)
    this.onChangeRoomType = this.onChangeRoomType.bind(this)
  }

  render() {
    var self = this;
    var buttons = [
      {
        name: I18n.t('cancel'),
        html_attributes: ['data-dismiss="modal"']
      },
      {
        name: I18n.t('submit'),
        button_classes: ['primary'],
        onClick: function (e) {
          self.onSave();
          return false;
        },
      },
    ]

    if (this.state.incidental_deposit) {
      return(
        <div className="incidental-deposit-builder">
          <div className="panel panel-form">
            <ModalButtons loading={this.state.loading} buttons={buttons} />
            <ModalHeader modalLoop={true} />
            {this.props.nested ? <IncidentalDepositBuilderGeneral {...this.props} {...this.state} /> : <Tabs tabs={this.tabs()} displayErrorMessage={(IncidentalDepositBuilderErrors.general(this.state.errors).length || IncidentalDepositBuilderErrors.room_types(this.state.errors).length) ? true : false} />}
            {this.props.nested ? null :
            <IncidentalDepositBuilderTabContent {...this.state}
               onChangeDepositType={this.onChangeDepositType}
               onChangeMaintainAuthorization={this.onChangeMaintainAuthorization}
               onChangeReauthorization={this.onChangeReauthorization}
               onChange={this.onChange}
               onChangeIncludeBalance={this.onChangeIncludeBalance}
               onChangeAmount={this.onChangeAmount}
               onChangePercentage={this.onChangePercentage}
               onChangeNights={this.onChangeNights}
               isChecked={this.isChecked}
               onChangeRoomType={this.onChangeRoomType}
               selectAllNone={this.selectAllNone}
              onChangeAuthorize={this.onChangeAuthorize}
              onChangeRichText={this.onChangeRichText}
             />}
          </div>
          <LoadingSpinner show={this.state.loading} />
        </div>
      )
    } else {
      return(
        <div>
          {null}
        </div>
      )
    }
  }

  tabs() {
    return (
      [
        {
          tabName: I18n.t('general'),
          targetName: 'general',
          classes: this.state.active_tab === 'general' ? 'active' : null,
          changeHandler: this.onChangeActiveTab,
          tabErrorCount: IncidentalDepositBuilderErrors.general(this.state.errors).length
        },
        {
          tabName: I18n.t('room_types'),
          targetName: 'room-types',
          classes: this.state.active_tab === 'room-types' ? 'active' : null,
          changeHandler: this.onChangeActiveTab,
          tabErrorCount: IncidentalDepositBuilderErrors.room_types(this.state.errors).length
        },
      ]
    );

  };

  prepParams() {
    var incidental_deposit = this.state.incidental_deposit

    if (incidental_deposit.deposit_type === "store_a_valid_card" || incidental_deposit.deposit_type === "none") {
      incidental_deposit['incidental_percentage'] = null
      incidental_deposit['incidental_amount'] = null
      incidental_deposit['incidental_nights'] = null
      incidental_deposit['include_reservation_balance'] = false
      incidental_deposit['reauthorize'] = null
    }
    return incidental_deposit
  }

  onSave() {
    var incidental_deposit = this.prepParams()
    var self = this;

    this.setState({loading: true});

    $.ajax({
      type: self.props.new_record ? 'POST' : 'PATCH',
      url: this.props.form_action,
      data: {
        incidental_deposit: incidental_deposit,
        room_type_ids: incidental_deposit.room_type_ids
      }
    }).done((data) => {
      window.parent.$(window.parent).trigger('incidentalDepositSaved', data);

      this.setState({loading: false});
      if (parent && parent.refresh_data) {
        if(this.props.new_record == true) {
          parent.refresh_data(I18n.t('incidental_deposit_created_successfully'));
        } else {
          parent.refresh_data(I18n.t('incidental_deposit_saved_successfully'));
        }
      }

      if (parent && parent.hide_modal) {
        parent.hide_modal();
      }

    }).catch((data) => {
      if (data && data.responseJSON) {
        this.setState({errors: data.responseJSON, loading: false});
        $('.modal-body').scrollTop(0);
      }
    });

  }

  onChangeAmount(value) {
    if (value) {
      var incidental_deposit = this.state.incidental_deposit
      incidental_deposit['incidental_amount'] = value
      incidental_deposit['incidental_percentage'] = null
      incidental_deposit['incidental_nights'] = null
      this.setState({incidental_deposit: incidental_deposit});
    }
  }

  onChangePercentage(value) {
    if (value) {
      var incidental_deposit = this.state.incidental_deposit
      incidental_deposit['incidental_percentage'] = value
      incidental_deposit['incidental_amount'] = null
      incidental_deposit['incidental_nights'] = null
      this.setState({incidental_deposit: incidental_deposit});
    }
  }

  onChangeNights(nights) {
    var incidental_deposit = this.state.incidental_deposit
    incidental_deposit['incidental_nights'] = nights.target.value
    incidental_deposit['incidental_percentage'] = null
    incidental_deposit['incidental_amount'] = null
    this.setState({incidental_deposit: incidental_deposit});
  }

  onChangeIncludeBalance(e) {
    var incidental_deposit = this.state.incidental_deposit;
    incidental_deposit['include_reservation_balance'] = e.target.checked;
    this.setState({incidental_deposit: incidental_deposit});
  }

  onChange(e) {
    var incidental_deposit = Object.assign({}, this.state.incidental_deposit);
    incidental_deposit[e.target.name] = e.target.value;
    this.setState({incidental_deposit: incidental_deposit});
  }

  onChangeRichText = (name, richText) => {
    var incidental_deposit = Object.assign({}, this.state.incidental_deposit);
    incidental_deposit[name] = richText;
    this.setState({ incidental_deposit: incidental_deposit });
  };

  onChangeAuthorize(e) {
    let incidental_deposit = Object.assign({}, this.state.incidental_deposit)
    incidental_deposit.pre_authorization = e.target.checked
    this.setState({incidental_deposit: incidental_deposit})
  }

  onChangeDepositType(e) {
    var incidental_deposit = this.state.incidental_deposit;
    if(e.target.value == "none" || "no_deposit") {
      incidental_deposit['deposit_type'] = e.target.value;
      incidental_deposit.pre_authorization = false
    } else {
      incidental_deposit['deposit_type'] = e.target.value;
    }
    this.setState({incidental_deposit: incidental_deposit});
  }

  onChangeReauthorization(event) {
    var incidental_deposit = this.state.incidental_deposit;
    incidental_deposit['reauthorize'] = event.target.value;
    this.setState({incidental_deposit: incidental_deposit});
  }

  onChangeActiveTab(active_tab) {
    this.setState({
      active_tab: active_tab
    })
  }

  setActiveTab(name, event) {
    event.preventDefault();
    this.setState({activeTab: name});
  }

  onChangeMaintainAuthorization(e) {
    var incidental_deposit = this.state.incidental_deposit
    if (e.target.checked === true) {
      if (incidental_deposit['reauthorize'] != null && incidental_deposit['reauthorize'] != "") {
        return
      } else {
        incidental_deposit['reauthorize'] = 'nightly'
      }
    } else {
      incidental_deposit['reauthorize'] = null
    }
    this.setState({
      maintain_authorization: e.target.checked,
      incidental_deposit: incidental_deposit,
    })
  }

  onChangeRoomType(selected_inputs) {
    var incidental_deposit = {...this.state.incidental_deposit}
    incidental_deposit.room_type_ids = selected_inputs
    this.setState({incidental_deposit: incidental_deposit})
  }

};

export default IncidentalDepositBuilder